export type HeadCell = {
  id: string;
  label: string;
  order: string;
  description?: {
    title: string;
    points: string[];
  };
};

export type TooltipDescription = {
  title: string;
  points: string[];
};

export enum Order {
  Asc = 'asc',
  Desc = 'desc',
  NA = 'NA',
}

export type Row = {
  cells: { [key: string]: unknown };
  link?: string;
};

export type Settings = {
  order?: Order;
  orderBy?: string;
  page?: number;
  rowsPerPage?: number;
  count?: number;
};
